import React from 'react';
import { Typography } from 'antd';
import styles from './client-description.module.scss';

const { Text } = Typography;

interface IClientDescriptionProps {
  description: string;
}

export const ClientDescription: React.FC<IClientDescriptionProps> = (props) => {
  const { description } = props;

  return <Text className={styles.description}>{description}</Text>;
};
